<template>
  <div class="product-table">
    <div class="headings">
      <h1 v-if="groupTitle" v-html="groupTitle"></h1>
      <h2>{{ table.title || "Produktauswahl" }}</h2>
    </div>

    <table class="table is-striped is-narrow">
      <thead>
      <tr>
        <th v-for="(column, key) in table.config" v-if="!column.disabled" :key="key" v-html="column.label"></th>
      </tr>
      </thead>
      <tbody>
      <template v-for="(product, productIndex) in table.data">
        <tr v-for="multiRowIndex in _.get(product, table.multiRowPath, 1)"
            :key="productIndex + '-' + multiRowIndex" :class="multiRowIndex === 1 ? 'parentRow' : 'childRow'">
          <tablefield
            v-for="(column, columnIndex) in table.config"
            :key="productIndex + '-' + multiRowIndex + '-' + columnIndex"
            :column="column"
            :product="product"
            :secondary-index="multiRowIndex - 1"
          ></tablefield>
        </tr>
      </template>
      </tbody>
    </table>
  </div>
</template>

<script>
import Tablefield from "../table-field/FieldContainer.vue";
import {Table} from "../../model/table/Table";

export default {
  components: {Tablefield},
  name: 'shortlist-table',
  props: {
    table: {
      type: Table,
      required: true
    },
    showTime: {
      type: Boolean,
      required: false,
      default: true
    },
    groupTitle: {
      type: String,
      required: false,
      default: null
    }
  },
  computed: {
    time() {
      return this.moment().format('[Stand:] DD. MMMM YYYY, HH:mm [Uhr]')
    }
  },
}
</script>



// WEBPACK FOOTER //
// TableShortlistProducts.vue?7aa754b9